import type { FieldType, FormField } from '@cli-types/core-engine/schema.js'
import type { BuiltInEntityFilterKey } from '@cli-types/next-adapter/generators.js'

export const FILTERABLE_FIELD_TYPES = new Set<FieldType>([
  'string',
  'email',
  'varchar',
  'text',
  'boolean',
  'number',
  'decimal',
  'date',
  'timestamp',
  'time',
  'select'
])
export const BUILT_IN_FILTER_KEYS = new Set<BuiltInEntityFilterKey>(['status', 'createdAt'])
export const SEARCHABLE_FORM_FIELD_TYPES = new Set<FormField['type']>([
  'text',
  'textarea',
  'email',
  'phone',
  'url',
  'select',
  'radio'
])
export const SORTABLE_FORM_FIELD_TYPES = new Set<FormField['type']>([
  'text',
  'textarea',
  'email',
  'phone',
  'number',
  'url',
  'date',
  'select',
  'radio',
  'checkbox',
  'timezone'
])
export const ENTER_PLACEHOLDER_FIELD_TYPES = new Set([
  'string',
  'email',
  'varchar',
  'text',
  'markdown',
  'richtext',
  'number',
  'decimal',
  'textarea',
  'phone',
  'url'
])
export const SELECT_PLACEHOLDER_FIELD_TYPES = new Set(['select', 'multiselect'])
export const NON_PLACEHOLDER_FIELD_TYPES = new Set([
  'group',
  'section',
  'tabs',
  'separator',
  'list',
  'dynamicFields'
])
